import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip, TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { abbrNumberFilter } from "app/filters/ngFilters";

import { parsePublisherLabel } from "./verification-widget.utils";
import { PublisherLabelText, PublisherLabelWrapper } from "./VerificationWidget.styles";

const CountText = styled(Text)`
    cursor: help;
`;

const formatAbbr = abbrNumberFilter();

const PublisherLabel = ({ label }: { label: string }) => {
    const { translate } = useTranslate();
    const { name, count } = parsePublisherLabel(label);

    if (count === null) {
        return (
            <PublisherLabelText>
                <TruncatedTextWithTooltip fontVariant="chip1">{label}</TruncatedTextWithTooltip>
            </PublisherLabelText>
        );
    }

    return (
        <PublisherLabelWrapper>
            <TruncatedTextWithTooltip fontVariant="chip1">{name}</TruncatedTextWithTooltip>
            <Tooltip content={translate("ad.intelligence.verification.publisher_label.count_tooltip")}>
                <CountText
                    fontVariant="chip1"
                    color={colorsPalettes.carbon[300]}
                    as="span"
                >
                    ({formatAbbr(count)})
                </CountText>
            </Tooltip>
        </PublisherLabelWrapper>
    );
};

export const renderPublisherLabel = (key: string) => <PublisherLabel label={key} />;
